import { render, staticRenderFns } from "./billing-record-list-dong-hai-guang-dong.vue?vue&type=template&id=32d65178&"
import script from "./billing-record-list-dong-hai-guang-dong.vue?vue&type=script&lang=js&"
export * from "./billing-record-list-dong-hai-guang-dong.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports